module.exports = __webpack_public_path__ + "img/社会责任类.d89b7328.png";